/**
 * BgcReverifyBanner — gentle nudge in Account when a member's background
 * check is older than 12 months. Uses the existing useBackgroundCheck hook.
 * Renders nothing for un-verified or recently-verified members.
 */
import { Link } from "react-router-dom";
import { Calendar } from "lucide-react";
import { useBackgroundCheck } from "@/lib/safety/useBackgroundCheck";

const TWELVE_MONTHS_MS = 365 * 24 * 60 * 60 * 1000;

const BgcReverifyBanner = () => {
  const { row, isPassed } = useBackgroundCheck();
  if (!row || !isPassed) return null;
  const checkedAt = row.completed_at;
  if (!checkedAt) return null;
  const age = Date.now() - new Date(checkedAt).getTime();
  if (age < TWELVE_MONTHS_MS) return null;

  return (
    <div className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-4 text-sm">
      <div className="flex items-start gap-3">
        <Calendar className="mt-0.5 h-4 w-4 text-amber-500" />
        <div className="flex-1">
          <p className="font-medium text-foreground">Time to refresh your background check</p>
          <p className="mt-1 text-xs text-muted-foreground">
            Your check is over a year old. Refreshing keeps your verified badge current and helps the community trust your profile.
          </p>
          <Link
            to="/safety#bgc"
            className="mt-2 inline-block text-xs font-medium text-primary hover:underline"
          >
            Refresh now →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BgcReverifyBanner;
